<template>
  <transition
    name="login-modal-fancy"
    appear
    @before-enter="beforeEnter"
    @after-leave="afterLeave"
  >
    <div
      class="login_wrapper hms"
      v-if="options.isLoginDialog"
    >
      <div class="login_wrapper_pc login fl">
        <div class="login_box_modal" :class="{ bounceOut: isAni }">
          <form class="form">
            <dl>
              <span class="logo"><span class="iconfont icon-yonghu1 title_iconfont"></span>會員中心</span>
              <div class="con">
                <div>
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <div class="userInput">
                      <el-form-item prop="userName">
                        <div>
                          <dd class="hms_account">
                            <span class="iconfont icon-yonghu1"></span>帳號
                            <span class="hms_after">Account</span>
                          </dd>
                          <dd class="userName">
                            <el-input
                              placeholder="帳號限6-18字元"
                              class="inp"
                              v-model="ruleForm.userName"
                            ></el-input>
                          </dd>
                        </div>
                      </el-form-item>

                      <el-form-item prop="passWord">
                        <div>
                          <dd class="hms_password">
                            <span class="iconfont icon-mima"></span>密碼
                            <span class="hms_after">Password</span>
                          </dd>
                          <dd class="passWord">
                            <el-input
                              type="password"
                              placeholder="密碼限6-18字元"
                              class="inp"
                              v-model="ruleForm.passWord"
                              @keyup.enter.native="submitForm('ruleForm')"
                            ></el-input>
                          </dd>
                        </div>
                      </el-form-item>

                      <div class="clear"></div>

                      <el-form-item>
                        <dd class="register flexCenter">
                          <router-link :to="{ path: '/memberCenter', query: { type: 'forgetPassword' } }"
                          @click.native="closeModal">忘記密碼
                          </router-link>
                          <router-link :to="{ path: '/memberCenter', query: { type: 'register' } }"
                          @click.native="closeModal">註冊帳號
                          </router-link>
  <!--                        <a @click="accountCancel">註銷帳號</a>-->
                        </dd>
                      </el-form-item>

                      <el-form-item>
                        <dd>
                          <a
                            href="javascript:;"
                            type="primary"
                            class="btn_login"
                            @click="submitForm('ruleForm')"
                          >登 入
                          </a>
                        </dd>
                      </el-form-item>
                      <el-form-item>
                        <dd class="thirdLogin">
                          <a href="javascript:;" @click="thirdLoginDialog('facebook')"></a>
                          <a href="javascript:;" @click="thirdLoginDialog('google')"></a>
                          <a href="javascript:;" @click="thirdLoginDialog('apple')"></a>
                        </dd>
                      </el-form-item>
                    </div>
                  </el-form>
                </div>
              </div>
            </dl>
          </form>
        </div>
  <!--      <div class="login_box login_in" :class="{ bounceOut: isAni }" v-else>-->
  <!--        <form class="form">-->
  <!--          <dl>-->
  <!--          <span class="logo pic_logo">-->
  <!--            <span class="pic">-->
  <!--              <img-->
  <!--                :src="this.$store.state.userInfo.head_img || defaultHead"-->
  <!--                alt-->
  <!--                width="100%"-->
  <!--              />-->
  <!--            </span>-->
  <!--          </span>-->
  <!--            <div class="sys_name">-->
  <!--              <span>{{ this.$store.state.userInfo.account }}</span>-->
  <!--              <router-link to="/" @click.native="loginOut">登出</router-link>-->
  <!--              <a style="cursor: pointer" @click="accountCancel">註銷帳號</a>-->
  <!--            </div>-->
  <!--          </dl>-->
  <!--        </form>-->
  <!--      </div>-->
  <!--      <account-cancel-->
  <!--        v-if="showAccountCancel"-->
  <!--        :show_account_cancel="showAccountCancel"-->
  <!--        :games-list="gamesList"-->
  <!--        @closeDialog="closeCancelDialog"-->
  <!--      />-->
      </div>
    </div>
  </transition>
</template>

<script>
import AccountCancel from "@/pc/components/memberCenter/AccountCancel.vue";
import '../../assets/styles/login.css';
import Loading from '../common/Loading';

export default {
  name: 'LoginModal',
  props: {
    options:Object,
    platFormType: String,
  },
  inject: ['reload'],
  components: {
    AccountCancel,
    Loading,
  },
  data: function () {
    return {
      isAni: false,
      passWord: "",
      isRemember: "",
      checked: true,
      account: "",
      isFbDialog: false,
      ruleForm: {
        userName: "",
        passWord: "",
      },
      rules: {
        userName: [{ required: true, message: "請輸入帳號", trigger: "blur" }],
        passWord: [
          { required: true, message: "請輸入密碼", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "用戶名長度在6-18位字符",
            trigger: "blur",
          },
        ],
      },
      defaultHead: "../../imgs/head.png",
      showAccountCancel: false,
      gamesList: [],
      showDialog: false,
    };
  },
  watch: {
    'options.isLoginDialog': {
      immediate: true,
      handler(val) {
        if (val) {
          this.showDialog = true;
        } else {
          // 延迟隐藏，等待动画完成
          setTimeout(() => {
            this.showDialog = false;
          }, 500); // 500ms需与动画时长一致或略大
        }
      }
    }
  },
  created() {
    let self = this;
    this.$bus.on("registerSuccess", function (val) {
      self.$store.commit("setIsHmsLogin", val);
    });
    this.$bus.on("homeLoginShow", function (val) {
      self.$store.commit("setIsHmsLogin", val);
    });
  },
  computed: {
    isHmsLogin: function () {
      return this.$store.state.isHmsLogin;
    },
  },
  mounted() {
    this.ruleForm.userName = "";
    this.ruleForm.passWord = "";
    if (localStorage.getItem("token")) {
      this.$store.commit("setIsHmsLogin", false);
    } else {
      this.$store.commit("setIsHmsLogin", true);
    }
    this.getCancelGamesList();
  },
  methods: {
    closeFbDialog: function () {
      this.$emit('closeFbDialog')
    },
    thirdLoginDialog: function (type) {
      this.$emit("thirdLoginDialog", type);
    },
    morefunLogin: function (userName, passWord) {
      this.options.isLoading = true;
      let datas = {
        account: userName,
        password: passWord,
      };
      this.postHttp(this, datas, "/front/login", function (obj, data) {
          if (data.status === 2000) {
            obj.account = data.data.user_info.account;
            let token = data.data.bear_token;
            let userInfo = data.data.user_info;
            obj.$store.commit("setToken", token);
            obj.$store.commit("setUserInfo", userInfo);
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            obj.$store.commit("setIsHmsLogin", false);
            obj.options.isLoading = false;
            obj.$toast(data.message);
            obj.ruleForm.userName = "";
            obj.ruleForm.passWord = "";
            obj.$bus.emit("loginSuccess", 0);
            obj.$emit("closeDialog")
          } else {
            obj.options.isLoading = false;
            obj.ruleForm.userName = "";
            obj.ruleForm.passWord = "";
            obj.$store.commit("setIsHmsLogin", true);
            obj.$toast(data.message);
          }
      });
    },
    submitForm: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.morefunLogin(this.ruleForm.userName, this.ruleForm.passWord);
        } else {
          console.log("錯誤的提交 !!");
          return false;
        }
      });
    },
    loginOut: function () {
      this.options.isLoading = true;
      this.options.isLoading = false;
      this.$store.commit("setIsHmsLogin", true);
      // localStorage.removeItem("token");
      // localStorage.removeItem("userInfo");
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      this.$emit("LoginRegisterShow", true);
      this.$toast("已登出");
      this.$router.push({ path: "/home" });
      // this.$store.commit("loginOut");
    },
    dateToMs: function (date) {
      let result = new Date(date).getTime();
      return result;
    },
    accountCancel: function () {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("請先登錄帳號");
      } else {
        this.showAccountCancel = true;
      }
    },
    closeCancelDialog(val) {
      this.showAccountCancel = val;
    },
    getCancelGamesList: function () {
      let token = localStorage.getItem('token')
      if(token) {
        this.getHttp(this, "", "/front/user/games", function (obj, data) {
          if (data.status === 2000) {
            obj.gamesList = data.data.games_list;
          }
        });
      }
    },
    toLink: function (appid) {
      // this.options.isLoading = true
      // if (this.platFormType === 'facebook') {
      //   this.url =
      //     'https://sdk.gamemorefun.com/mobile/v1/passport/facebook/5?app_id=' +
      //     appid +
      //     '&redirect_url=https%3A%2F%2Fwww.hermesgames.com.tw%2F%23%2F'
      // }
      //
      // if (this.platFormType === 'google') {
      //   this.url =
      //     'https://sdk.gamemorefun.com/rest/v2/passport/google/5?app_id=' +
      //     appid +
      //     '&redirect_url=https%3A%2F%2Fwww.hermesgames.com.tw%2F%23%2F'
      // }
      //
      // if (this.platFormType === 'apple') {
      //   this.url =
      //     'https://sdk.gamemorefun.com/rest/v2/passport/apple/5?app_id=' +
      //     appid +
      //     '&redirect_url=https%3A%2F%2Fwww.hermesgames.com.tw%2F%23%2F'
      // }
      // setTimeout(()=>{
      //   this.options.isLoading = false
      // },2000)
      // window.location.href = this.url
    },
    closeModal: function () {
      this.$emit('closeDialog')
    },
    beforeEnter(el) {
      // 可选：进入前可做初始化
    },
    afterLeave(el) {
      // 可选：离开后可做清理
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-enter, .v-enter-to {
  opacity: 0;
}

.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

  .login_wrapper{
    width: 680px;
    height: 638px;
    position: fixed;
    left calc(50% - 340px);
    top calc(50% - 319px);
    z-index 120
    background-color: #ffffff;
    box-shadow: 0px 17px 32px 0px rgba(0, 0, 0, 0.14);
    border-radius: 20px;
    transition: opacity 0.3s;
    opacity: 1;
  }
.login >>> .el-form-item__error {
  color: #F56C6C;
  top: 100%;
  left: 4px;
  font-size: 14px;
}

.login >>> .el-input__inner:-webkit-autofill {
  background-color: #fff !important;
  background: #fff !important;
  box-shadow: 2px 0 2px 0 rgba(3, 3, 3, 0.35) inset, 0 2px 2px 0 rgba(3, 3, 3, 0.35) inset, 0 -2px 2px 0 rgba(3, 3, 3, 0.35) inset, -2px 0 2px 0 rgba(3, 3, 3, 0.35) inset !important;
}

.login >>> .userName .el-input__inner, .login >>> .passWord .el-input__inner {
  width: 353px;
  height: 49px;
  border-radius: inherit;
  background: url('../../assets/imgs/inp_bg.jpg');
  background-size: 100% 100%;
}

.login >>> .el-input__inner:-webkit-autofill {
  background-color: transparent;
}

.login_wrapper_pc {
  width: 421px;
  height: 556px;
  position: fixed;
  left calc(50% - 210.5px);
  top calc(50% - 278px);
  .title_iconfont{
    font-size 39px !important
  }
  .el-form{
    .iconfont{
      font-size: 28px;
    }
  }

  .btn_login, .el-form-item {
    margin-bottom: 0 !important;
  }

  .btn_login {
    display inline-block;
    width: 414px;
    height: 90px;
    margin-top: 17px;
    margin-bottom 27px;
    margin-left -37px
    font-family: '微软雅黑';
    background: url('../../assets/imgs/dawudao/btn_loginModal.png') no-repeat center;
    background-size: 100% 100%;
    transition: transform 0.3s;
    text-indent: -9999px;

    &:hover {
      transform translateY(-5px)
    }
  }

  .forgetPassword {
    input[name='checkbox'] {
      margin-top: 12px !important;
      margin-right: 9px !important;
    }
  }

  .register {
    text-align: left;
    margin: 25px 0 5px;

    a {
      font-size: 33px;
      color: #333333;
      cursor: pointer;

      &:hover {
        color: #fcc916;
        text-decoration: underline;
      }

      &:nth-child(2) {
        margin-left: 22px;
      }
      &:nth-child(3) {
        margin-left: 22px;
      }
    }

    .el-checkbox__label {
      color: #fff;
    }

    em {
      display: inline-block;
      width: 15.29px;
      height: 15.29px;
      background: #fff;
      margin-right: 8px;
    }
  }

  .login_box_modal {
    text-align: center;

    .form {
      dl {
        overflow: inherit;
      }
    }

    .login_close {
      position: absolute;
      width: 89px;
      height: 82px;
      right: 0;
      top: 0;
      border-top-right-radius: 30%;
      background: url('../../assets/imgs/close.png') no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;

      i {
        display: inline-block;
        width: 31.67px;
        height: 5.65px;
        position: absolute;
        right: 9px;
        top: 18px;
        background: #ffffff;
        border-radius: 2.5px;
      }
    }

    .logo {
      position: relative;
      display: inline-block;
      width: 365px;
      height: 50px;
      margin-top: -10px;
      font-size: 37px;
      color: #333333;
      border-bottom: 3px solid #fcc505;
      .icon-memberCenter{
        font-size:37px !important
      }

      i {
        display: inline-block;
        width: 70px;
        height: 51px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -35px;
        margin-top: -25.5px;
        background: #ffffff;
        border-radius: 2.5px;
      }
    }

    .pic {
      display: inline-block;
      width: 42px;
      height: 50px;
    }

    .pic_logo {
      height: 56px;

      &::before {
        content: '';
        background: none;
      }
    }

    .sys_name {
      margin-top: 10px;

      span {
        color: #fff;
        font-size: 18px;
        display: block;
      }

      a {
        margin-left: 6px;
        color: #fff;
        font-size: 12x;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .icon {
      span {
        display: inline-block;
        color: #545454;
        font-size: 14px;
        vertical-align: top;
        margin-right: 25px;
        margin-top: 8px;
      }

      div {
        display: inline-block;
        width: 39px;
        height: 46px;
        margin-top: 8px;
        background: url('../../assets/imgs/game-icon.png') no-repeat center;
        background-size: 500px 500px;
        cursor: pointer;

        &.gg {
          background-position: 0 -166px;
        }

        &.tw {
          background-position: -61px -166px;
        }

        &.fb {
          background-position: -123px -166px;
        }
      }
    }

    .login_reg {
      a {
        color: #2c2c2c;
        font-size: 14px;
      }
    }

    .userInput {
      width 351px
      height 259px
      margin: 0 auto;
      padding: 0 10px;

      .thirdLogin {
        position: relative;
        width: 229px;
        height: 63px;
        margin: 0 auto;
        a {
          content: '';
          position: absolute;
          width: 64px;
          height: 64px;
          top: 50%;
          margin-top: -15px;
          background: url('../../assets/imgs/btn_third_login.png') no-repeat center;
          background-size: 229px 63px;
          opacity: 1;

          &:hover {
            opacity: 0.85;
          }

          &:nth-child(1) {
            left: 0;
            background-position: 0 0;
          }

          &:nth-child(2) {
            left: 50%;
            margin-left: -32px;
            background-position: -84px 0;
          }

          &:nth-child(3) {
            right: 0;
            background-position: -166px 0;
          }
        }
      }

      .hms_account, .hms_password {
        position: relative;
        width: 100%;
        text-align: left;
        color: #333333;
        font-size: 37px;
      }

      .hms_account {
        margin-top: 27px;
      }

      .hms_password {
        margin-top: 20px;
      }

      .hms_after {
        font-size: 20.83px;
      }

      dd {
        position: relative;
      }

      .el-input__inner {
        font-size: 22px;
        text-align: center;
      }

      .el-input {
        display: inherit;
      }
    }
  }

}
  /* 丝滑缩放弹窗动画 */
.login-modal-fancy-enter-active {
  animation: loginModalSmoothIn 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
.login-modal-fancy-leave-active {
  animation: loginModalSmoothOut 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.login-modal-fancy-leave-to {
  opacity: 0 !important;
  pointer-events: none !important;
}
.login-modal-fancy-enter-from, .login-modal-fancy-leave-to {
  opacity: 0;
  transform: scale(0.7);
  filter: blur(4px) brightness(1.2);
}
.login-modal-fancy-enter-to, .login-modal-fancy-leave-from {
  opacity: 1;
  transform: scale(1);
  filter: blur(0) brightness(1);
}

@keyframes loginModalSmoothIn {
  0% {
    opacity: 0;
    transform: scale(0.7);
    filter: blur(4px) brightness(1.2);
  }
  60% {
    opacity: 1;
    transform: scale(1.04);
    filter: blur(1px) brightness(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0) brightness(1);
  }
}

@keyframes loginModalSmoothOut {
  0% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0) brightness(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.7);
    filter: blur(4px) brightness(1.2);
  }
}
</style>
